<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <ak-model-filter-card model="applet" @search="search" @reset="reset" :value="where"/>
    <div class="myCard">
        <ak-model-card model="applet" ref="applet" :page.sync="page" :filters="filters" tableSize="small"/>
    </div>
  </div>
</template>
<script>
import qs from 'qs'
import Breadcrumb from '../../components/tools/Breadcrumb.vue'

export default {
  components: {
    Breadcrumb
  },
  data () {
    return {
      filters: {
        isDelete: { $ne: true },
        userRole: { $exists: true }
      },
      page: Number(this.$route.query.page) || 1
    }
  },
  watch: {
    page (val) {
      this.reRoute()
    }
  },
  computed: {
    where () {
      let where = { ...this.filters }
      for (let i in where) {
        if (where[i].$regex) {
          where[i] = where[i].$regex
        }
        if (where[i].$exists) {
          delete where[i]
        }
      }
      return where
    }
  },
  mounted () {
    this.filters = {
      ...this.filters,
      ...this.$route.query.filters ? qs.parse(this.$route.query.filters) : {}
    }
  },
  methods: {
    search (filters) {
      this.page = 1
      this.filters = { isDelete: { $ne: true }, userRole: { $exists: true } }
      this.filters = { ...this.filters, ...filters }
      this.reRoute()
    },
    reset () {
      this.page = 1
      this.filters = { isDelete: { $ne: true }, userRole: { $exists: true } }
      this.reRoute()
    },
    reRoute () {
      let query = {}
      if (Number(this.page) > 1) query.page = this.page
      if (this.filters && Object.keys(this.filters).length > 0) query.filters = qs.stringify(this.filters)
      // if (this.orderBy) query.orderBy = this.orderBy
      // if (this.category) query.category = this.category
      this.$router.push({
        path: this.$route.path,
        query: query
      }).catch(() => {})
    }
  }
}
</script>
  <style lang="scss" scoped>
  .myTab {
    padding: 24px 0 0 24px;
  }
  </style>
